namespace $.$$ {

	type $shm_hitalama_map_page_arrow_kind = 'settings' | 'code' | 'table' | 'value' | 'filter' | 'method'

	export class $shm_hitalama_map_page_arrows extends $.$shm_hitalama_map_page_arrows {

		@ $mol_mem
		widget_arrow_ids() {
			const page = this.Map_page() as $shm_hitalama_map_page
			const widgets = page.widgets_filtered()
			const types = page.widgets_filtered_types
			let visible: Set< string > | null = null
			const visible_ensure = ()=> visible ??= new Set( widgets.map( widget => widget.link_str() ) )
			const ids: string[] = []

			widgets.forEach( ( widget, index ) => {
				const type = types[ index ] ?? widget.type()
				const value_links = this.widget_arrow_value_links(
					widget,
					type,
					type == 'text' ? widget.value_refs() : null,
				)
				
				if( value_links.length && !this.widget_arrow_value_links_skipped( widget ) ) {
					const visible = visible_ensure()
					value_links.forEach( ref => {
						if( ref == widget.link_str() ) return
						if( !visible.has( ref ) ) return
						ids.push( JSON.stringify([ widget.link_str(), 'value', ref ]) )
					} )
				}
				if( type == 'text' && !value_links.length ) return

				if( type == 'method' ) {
					const visible = visible_ensure()
					this.widget_arrow_method_links( widget ).forEach( ref => {
						if( ref == widget.link_str() ) return
						if( !visible.has( ref ) ) return
						ids.push( JSON.stringify([ widget.link_str(), 'method', ref ]) )
					} )
				}

				if( [ 'chart', 'echarts' ].includes( type ) ) {
					const visible = visible_ensure()
					this.widget_arrow_table_links( widget ).forEach( ref => {
						if( !visible.has( ref ) ) return
						ids.push( JSON.stringify([ widget.link_str(), 'table', ref ]) )
					} )
				}

				if( type == 'chart_filter' ) {
					const visible = visible_ensure()
					this.widget_arrow_filter_links( widget ).forEach( ref => {
						if( !visible.has( ref ) ) return
						ids.push( JSON.stringify([ ref, 'filter', widget.link_str() ]) )
					} )
				}

				const settings = widget.settings_widget()
				const visible = visible_ensure()
				if( settings && !settings.removed() && visible.has( settings.link_str() ) ) {
					ids.push( JSON.stringify([ widget.link_str(), 'settings', settings.link_str() ]) )
				}

				const code = widget.code_widget()
				if( code && !code.removed() && visible.has( code.link_str() ) ) {
					if( this.widget_arrow_code_to_view_skipped( widget, code ) ) return
					ids.push( JSON.stringify([ widget.link_str(), 'code', code.link_str() ]) )
				}
			} )

			return ids
		}

		widget_arrow_code_to_view_skipped( widget: $shm_hitalama_map_widget, code: $shm_hitalama_map_widget ) {
			const view = code.view_widget()
			if( !view || view.link_str() != widget.link_str() ) return false

			const source_code = code.code_widget()
			return Boolean( source_code && !source_code.removed() && source_code.link_str() != widget.link_str() )
		}

		widget_arrow_value_links_skipped( widget: $shm_hitalama_map_widget ) {
			const code = widget.code_widget()
			if( !code || code.removed() ) return false

			const view = code.view_widget()
			return Boolean( view && view.link_str() == widget.link_str() )
		}

		widget_arrow_value_links(
			widget: $shm_hitalama_map_widget,
			type: $shm_hitalama_map_widget_def_type_name = widget.type(),
			value_refs: readonly string[] | null = type == 'text' ? widget.render_data().value_refs : null,
		) {
			if( type == 'file' ) return []
			if( value_refs ) return value_refs

			const texts = [
				type == 'text' ? widget.text() : widget.code(),
				type == 'code_sql' ? widget.code_sql().sql() : '',
				... type == 'table' ? [
					widget.table().Head_method()?.val() ?? '',
					widget.table().Rows_method()?.val() ?? '',
				] : [],
			]
			return [ ... new Set( texts.flatMap( text => $shm_hitalama_map_widget_value_refs( text ) ) ) ]
		}

		widget_arrow_method_links( method_widget: $shm_hitalama_map_widget ) {
			return this.Map_page().map().method_runtime().method_widget_links( method_widget )
		}

		widget_arrow_table_links( chart_widget: $shm_hitalama_map_widget ) {
			const table = chart_widget.chart().table()
			if( !table ) return []

			return this.Map_page().widgets_filtered().flatMap( widget => {
				if( widget.link_str() == chart_widget.link_str() ) return []
				if( ![ 'table', 'table_novirt', 'tabulator' ].includes( widget.type() ) ) return []
				return widget.table() == table ? [ widget.link_str() ] : []
			} )
		}

		widget_arrow_filter_links( filter_widget: $shm_hitalama_map_widget ) {
			const chart = filter_widget.chart()
			if( !chart ) return []

			return this.Map_page().widgets_filtered().flatMap( widget => {
				if( widget.link_str() == filter_widget.link_str() ) return []
				if( ![ 'chart', 'echarts' ].includes( widget.type() ) ) return []
				return widget.chart() == chart ? [ widget.link_str() ] : []
			} )
		}

		widget_arrows() {
			if( !this.visible() ) return []
			return this.widget_arrow_ids().map( id => this.Widget_arrow( id ) )
		}

		@ $mol_mem_key
		widget_arrow_parts( id: string ) {
			return JSON.parse( id ) as [ string, $shm_hitalama_map_page_arrow_kind, string ]
		}

		@ $mol_mem_key
		widget_arrow_from_widget( id: string ) {
			return this.Map_page().Widget( new $giper_baza_link( this.widget_arrow_parts( id )[2] ) ).Sub()
		}

		@ $mol_mem_key
		widget_arrow_to_widget( id: string ) {
			return this.Map_page().Widget( new $giper_baza_link( this.widget_arrow_parts( id )[0] ) ).Sub()
		}

		@ $mol_mem_key
		widget_arrow_kind( id: string ) {
			return this.widget_arrow_parts( id )[1]
		}

	}

}
